import { Spin, Table, Tooltip } from "antd";
import styles from "../styles/styles.module.css";
import { getColumnSearchProps } from "../../../utils/tables";
import { ReactComponent as Warning } from "../../../assets/icons/warning.svg";
import { ReactComponent as EyeBox } from "../../../assets/icons/eye-box.svg";
import { ReactComponent as Preparing } from "../../../assets/icons/preparing.svg";
import { ReactComponent as OrderList } from "../../../assets/icons/order-list.svg";
import { ReactComponent as AssignedDriver } from "../../../assets/icons/assigned-driver.svg";
import { ReactComponent as DriverInStore } from "../../../assets/icons/driver-in-store.svg";
import { ReactComponent as OnTheWay } from "../../../assets/icons/on-the-way.svg";
import { ReactComponent as RecentOrder } from "../../../assets/icons/recent-order.svg";
import { ReactComponent as PreparingWhite } from "../../../assets/icons/preparing-white.svg";
import { ReactComponent as OrderListWhite } from "../../../assets/icons/order-list-white.svg";
import { ReactComponent as DriverWhite } from "../../../assets/icons/driver-white.svg";
import { useSelector } from "react-redux";
import { selectDayOrders } from "../../../redux/slices/monitor";
import { useEffect, useRef, useState, useMemo } from "react";
import { selectUser } from "../../../redux/slices/user";

const TotalActiveOrders = ({ activeOrders, getActiveOrders, openDetails, loadingOrder, loadingTable, filtersRef, currentPage = 1, pageSize = 10, tableFilters = {}, onTableChange, onSearchApply }) => {
  const dayOrders = useSelector(selectDayOrders);
  const [orderType] = useState(-1);
  const orderStates = [
    {
      value: 6,
      text: "Orden nueva",
      items: dayOrders.filter((x) => x.status === 6).length,
    },
    {
      value: 7,
      text: "Preparando",
      items: dayOrders.filter((x) => x.status === 7).length,
    },
    {
      value: 8,
      text: "Driver Asignado",
      items: dayOrders.filter((x) => x.status === 8).length,
    },
    {
      value: 9,
      text: "Driver en tienda",
      items: dayOrders.filter((x) => x.status === 9).length,
    },
    {
      value: 10,
      text: "Orden lista",
      items: dayOrders.filter((x) => x.status === 10).length,
    },
    {
      value: 11,
      text:
        orderType === 1 || orderType === 0 ? "lista para recoger" : "En camino",
      items: dayOrders.filter((x) => x.status === 11).length,
    },
  ];
  const { peya_courier, ubereats, takeout, pedidosya, hotstop, domicilio } =
    activeOrders?.tiempo_avg_orden || {};
  const user = useSelector(selectUser);
  const isAdmin = user.admin;
  const firstRender = useRef(true);
  const searchInput = useRef(null);
  const totalAverageTime = [
    {
      title: "Última milla",
      value: peya_courier,
    },
    {
      title: "Domicilio (Propio)",
      value: domicilio,
    },
    {
      title: "Peya",
      value: pedidosya,
    },
    {
      title: "Uber eats",
      value: ubereats,
    },
    {
      title: "Para llevar",
      value: takeout,
    },
    {
      title: "Hotstop",
      value: hotstop,
    },
  ];

  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }

    getActiveOrdersHandler();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize, tableFilters]);

  useEffect(() => {
    const countup = setInterval(() => {
      getActiveOrdersHandler();
    }, 30000);

    return () => {
      clearInterval(countup);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize, tableFilters]);

  const getActiveOrdersHandler = () => {
    getActiveOrders({
      user: user.id,
      isAdmin,
      current: currentPage,
      pageSize: pageSize,
      filters: tableFilters,
    });
  };

  const getIconForStatus11Card = (orderType) => {
    return orderType === 1 || orderType === 0 ? (
      <OrderListWhite />
    ) : (
      <DriverWhite />
    );
  };
  const getIconForStatus11Table = (orderType) => {
    return orderType === 1 || orderType === 0 ? <OrderList /> : <OnTheWay />;
  };

  const getIcon = (status, orderType, type) => {
    if (status === 7) {
      return (
        <Tooltip title="Preparando" placement="top">
          {type === "card" ? <PreparingWhite /> : <Preparing />}
        </Tooltip>
      );
    } else if (status === 8) {
      return (
        <Tooltip title="Driver asignado" placement="top">
          {type === "card" ? <DriverWhite /> : <AssignedDriver />}
        </Tooltip>
      );
    } else if (status === 9) {
      return (
        <Tooltip title="Driver en tienda" placement="top">
          {type === "card" ? <DriverWhite /> : <DriverInStore />}
        </Tooltip>
      );
    } else if (status === 10) {
      return (
        <Tooltip title="Orden lista" placement="top">
          {type === "card" ? <OrderListWhite /> : <OrderList />}
        </Tooltip>
      );
    } else if (status === 11) {
      return (
        <Tooltip
          title={
            orderType === 1 || orderType === 0
              ? "lista para recoger"
              : "En camino"
          }
          placement="top"
        >
          {type === "card"
            ? getIconForStatus11Card(orderType)
            : getIconForStatus11Table(orderType)}
        </Tooltip>
      );
    }
    return (
      <Tooltip title="Orden nueva" placement="top">
        <RecentOrder />
      </Tooltip>
    );
  };

  const columns = useMemo(() => [
    {
      title: "Origen",
      dataIndex: "platformName",
      align: "center",
      filteredValue: tableFilters?.platformName ? [tableFilters.platformName] : null,
      ...getColumnSearchProps("platformName", searchInput, filtersRef, false, onSearchApply),
    },
    {
      title: "Ticket",
      dataIndex: "ticket",
      filteredValue: tableFilters?.ticket ? [tableFilters.ticket] : null,
      ...getColumnSearchProps("ticket", searchInput, filtersRef, false, onSearchApply),
      render: (val, record) => (
        <span>
          {(!record.cireba_remote_id || record.cireba_remote_id === "0") && (
            <Tooltip placement="top" title="Orden no ingresada a CIREBA">
              <Warning className={styles.warning} />
            </Tooltip>
          )}
          {val}
        </span>
      ),
    },
    {
      title: "Cliente",
      dataIndex: "id_user",
      render: (val) => val?.fullname,
      filteredValue: tableFilters?.id_user__name ? [tableFilters.id_user__name] : null,
      ...getColumnSearchProps("id_user__name", searchInput, filtersRef, false, onSearchApply),
    },
    {
      title: "Teléfono",
      dataIndex: "id_user",
      align: "center",
      render: (val) => val?.mobile,
      filteredValue: tableFilters?.id_user__mobile ? [tableFilters.id_user__mobile] : null,
      ...getColumnSearchProps("id_user__mobile", searchInput, filtersRef, false, onSearchApply),
    },
    {
      title: "Sucursal",
      dataIndex: "branch",
      align: "center",
      render: (val) => val?.zone || "-",
      filteredValue: tableFilters?.branch_name ? [tableFilters.branch_name] : null,
      ...getColumnSearchProps("branch_name", searchInput, filtersRef, false, onSearchApply),
    },
    {
      title: "Tipo de Orden",
      dataIndex: "orderTypeName",
      align: "center",
      filters: [
        { value: "PEDIDOS YA", text: "PEDIDOS YA" },
        { value: "UBER EATS", text: "UBER EATS" },
        { value: "PARA LLEVAR", text: "PARA LLEVAR" },
        { value: "DOMICILIO", text: "DOMICILIO" },
      ],
      filteredValue: tableFilters?.orderType ? [tableFilters.orderType] : null,
      filterMultiple: false,
      render: (value, record) => record.orderTypeName,
    },
    {
      title: "Estado",
      dataIndex: "status",
      align: "center",
      filters: orderStates,
      filteredValue: tableFilters?.status != null ? [tableFilters.status] : null,
      filterMultiple: false,
      render: (val, record) => (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {getIcon(val, record.orderType)}
          <span style={{ margin: 0 }}>
            {orderStates.find((x) => x.value === val)?.text}
          </span>
        </div>
      ),
    },
    {
      title: "Tiempo estado (min)",
      dataIndex: "tiempo_en_estado",
    },
    {
      title: "Tiempo total (min)",
      dataIndex: "tiempo_total",
    },
    {
      title: 'Driver',
      dataIndex: 'driver',
      render: (val) => val?.name || "-",
    },
    {
      title: 'Estimado entrega (min)',
      dataIndex: 'tiempo_estimado_entrega',
    },
    {
      title: "Ver detalle",
      dataIndex: "id",
      align: "center",
      render: (val) => (
        <button
          disabled={loadingOrder}
          onClick={() => openDetails(val)}
          className={styles.eye}
        >
          {loadingOrder === val ? <Spin size="small" /> : <EyeBox />}
        </button>
      ),
    },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  ], [tableFilters, orderStates, loadingOrder, filtersRef]);


  return (
    <div>
      <p className={styles.averageTimeName}>TIEMPO PROMEDIO TOTAL</p>
      <div className={styles.averageTimeContainer}>
        {totalAverageTime.map((item, index) => (
          <div key={index} className={styles.averageTimeBox}>
            <span className={styles.averageTimeTitle}>{item.value}</span>
            <span className={styles.averageTimeValue}>{item.title}</span>
          </div>
        ))}
      </div>

      <Table
        loading={loadingTable}
        dataSource={activeOrders?.orders || []}
        columns={columns}
        pagination={{
          current: currentPage,
          pageSize: pageSize,
          total: activeOrders?.total,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100'],
        }}
        onChange={onTableChange}
      />
    </div>
  );
};

export default TotalActiveOrders;
